export const API_DOMAIN = 'https://acacia.symliq.com/'
export const MEDICATION_REQUEST_URI =
    'https://www.getmyrefill.today/api/acacia/auth/'
